import { Injectable, Inject } from '@angular/core';
import { HttpClient, HttpResponse, HttpHeaders } from '@angular/common/http';
import { PagedData } from './paged-data.model';
import { Constants } from '../../constants';
import { URL_API_LUMILOGIN } from '../../lumilogin.token';

@Injectable()
export class WebServicesService {

	constructor(
		@Inject(URL_API_LUMILOGIN) private urlApiLumilogin: string,
		private httpClient: HttpClient
	) { }

	public getList<T>(resourcePath: string): Promise<PagedData<T>> {
		return this.httpClient.get<PagedData<T>>(this.urlApiLumilogin + resourcePath, { observe: 'response' }).toPromise()
			.then(res => this.extractPagedData<T>(res))
			.catch(this.handleError);
	}

	public getEntity<T>(resourcePath: string): Promise<T> {
		return this.httpClient.get<T>(this.urlApiLumilogin + resourcePath, { observe: 'response' }).toPromise()
			.then(res => this.extractData<T>(res))
			.catch(this.handleError);
	}

	public getBlob(resourcePath: string): Promise<any> {
		return this.httpClient.get(this.urlApiLumilogin + resourcePath, { responseType: 'blob' }).toPromise()
			.catch(this.handleError);
	}

	public post<T>(resourcePath: string, jsonBody: any): Promise<T> {
		return this.httpClient.post<T>(this.urlApiLumilogin + resourcePath, jsonBody, { observe: 'response', headers: this.newJsonHeaders() }).toPromise()
			.then(res => this.extractData<T>(res))
			.catch(this.handleError);
	}

	public put<T>(resourcePath: string, jsonBody: any): Promise<T> {
		return this.httpClient.put<T>(this.urlApiLumilogin + resourcePath, jsonBody, { observe: 'response', headers: this.newJsonHeaders() }).toPromise()
			.then(res => this.extractData<T>(res))
			.catch(this.handleError);
	}

	public postFile(resourcePath: string, file: any): Promise<any> {
		let formData: FormData = new FormData();
		formData.append('file', file, file.name);
		return this.httpClient.post(this.urlApiLumilogin + resourcePath, formData, { observe: 'response', headers: this.newFileHeaders() }).toPromise()
			.then(this.extractData)
			.catch(this.handleError);
	}

	public patch<T>(resourcePath: string, jsonBody: any): Promise<T> {
		return this.httpClient.patch<T>(this.urlApiLumilogin + resourcePath, jsonBody, { observe: 'response', headers: this.newJsonHeaders() }).toPromise()
			.then(res => this.extractData<T>(res))
			.catch(this.handleError);
	}

	public delete(resourcePath: string): Promise<any> {
		return this.httpClient.delete(this.urlApiLumilogin + resourcePath, { observe: 'response', headers: this.newJsonHeaders() }).toPromise()
			.then(this.extractData)
			.catch(this.handleError);
	}

	private extractData<T>(response: HttpResponse<T>): T {
		if (response.status === Constants.httpStatus.NO_CONTENT)
			return null;
		return response.body;
	}

	private extractPagedData<T>(response: HttpResponse<PagedData<T>>): PagedData<T> {
		if (response.status === Constants.httpStatus.NO_CONTENT)
			return new PagedData<T>();
		return response.body;
	}

	private handleError(response: HttpResponse<any>) {
		console.log('=== Erreur web services ===');
		if (response.body) {
			console.log(response.body);
			return Promise.reject(response.body);
		} else {
			console.log(response);
			return Promise.reject(response);
		}
	}

	newJsonHeaders(): HttpHeaders {
		return new HttpHeaders({ 'Content-Type': 'application/json' })
	}

	newFileHeaders(): HttpHeaders {
		return new HttpHeaders({ 'Accept': 'application/json' })
	}
}